function PermissionDenied() {
    return (
        <div className="builder_wrapper">
            <h1>Permission Denied</h1>
        </div>
    );
}
export default PermissionDenied;
